import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SupervisedUserCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"supervised_user_circle"}/>
}
